import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/vinted-restricted-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>Vinted Restricted Items: The prohibited products you should never list</title>
        <meta
          name='description'
          content='Prohibited items come with red flags you must be mindful of to keep your Vinted business in good standing.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/vinted-restricted-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/vinted-restricted-items' />
        <meta property='og:title' content='Vinted Restricted Items: The prohibited products you should never list' />
        <meta
          property='og:description'
          content='Prohibited items come with red flags you must be mindful of to keep your Vinted business in good standing.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
